import { useSearchParams } from "react-router-dom";

import { RestList, View } from "../../components/base";

export const AdminTemplatesPage = () => {
  const [searchParams] = useSearchParams();
  const isPanelOpen = searchParams.has("id");

  return (
    <View className="h-full w-full bg-gray-50 dark:bg-slate-900">
      <div className={`h-full w-full relative ${isPanelOpen ? "pr-[400px]" : ""} transition-all duration-300`}>
        <RestList
          className="h-full w-full"
          entityName="agentTemplate"
          fields={[
            {
              name: "id",
              label: "ID",
              readOnly: true,
            },
            {
              name: "name",
              label: "Name",
            },
            {
              name: "description",
              label: "Description",
            },
            {
              name: "category",
              label: "Category",
            },
            {
              name: "isPublic",
              label: "Public",
              type: "checkbox",
            },
          ]}
        />
      </div>
    </View>
  );
};
